"use client"

import {
  type UnionAddress,
  rawAddressToLowerCase,
} from "@anaconda/core/blockchain/address"
import { cn } from "@rarible_int/anaconda_ui_components"
import Avatar from "boring-avatars"
import { WalletAddress } from "../components/wallet-address"

interface Props {
  address: UnionAddress
  imageSize?: number
  className?: string
  withCopyIcon?: boolean
  withAvatar?: boolean
}

const DEFAULT_IMAGE_SIZE = 48

export function Address(props: Props) {
  const {
    address,
    imageSize,
    className,
    withCopyIcon,
    withAvatar = true,
  } = props

  return (
    <div
      className={cn("flex items-center gap-3", className)}
      data-testid="address"
    >
      {withAvatar && <ProfileAvatar imageSize={imageSize} address={address} />}
      <WalletAddress address={address} withCopyIcon={withCopyIcon} />
    </div>
  )
}

export function ProfileAvatar({
  imageSize,
  address,
  className,
}: {
  imageSize?: number
  address: UnionAddress
  className?: string
}) {
  const lowerCaseAddress = rawAddressToLowerCase(address)

  return (
    <Avatar
      name={lowerCaseAddress}
      size={imageSize ?? DEFAULT_IMAGE_SIZE}
      data-testid="profile-avatar"
      aria-label={lowerCaseAddress}
      className={className}
    />
  )
}
